import React from "react";
import {
    Badge,
    Tooltip,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuGroup,
    Icon
} from "@chakra-ui/react";

import { ChevronDownIcon } from "@chakra-ui/icons";

const RelevanceBadge = ({
    value,
    editable = false,
    onChange
}) => {
  const color = () => {
    switch (value) {
        case "HIGH":
            return "red";
        case "MEDIUM":
            return "yellow";
        case "LOW":
            return "gray";
        default:
            return "";
    }

};
const badge = (
    <Badge
        colorScheme={color()}
        variant="subtle"
        fontSize="11px"
        px={2}
        py={1}
        borderRadius="md"
        display="flex"
        alignItems="center"
        gap="4px"
        w="fit-content"
        cursor={editable ? "pointer" : "default"}
    >
        {value}

        {editable && (
            <Icon
                as={ChevronDownIcon}
                boxSize={3}
            />
        )}
    </Badge>
);

return (
    <Tooltip
        label="Relevance"
        bg="gray.200"
        color="black"
        placement="top"
    >
        {editable ? (

            <Menu>
                <MenuButton>
                    {badge}
                </MenuButton>


                <MenuList minW="90px" py={1}>
                    <MenuGroup title='Relevance' fontSize="12px" m="2" my="1">

                    {["HIGH", "MEDIUM", "LOW"].map((item) => (
                    <MenuItem
                    key={item}
                    fontSize="12px"
                    minH="28px"
                    py={1}
                    onClick={() => onChange(item)}
                    >
                    {item}
                    </MenuItem>
                ))}
                </MenuGroup>
                </MenuList>
                </Menu>
        ) : (
            badge
        )}
    </Tooltip>
);
}


export default RelevanceBadge;